<template>
  <NavComponents/>
  <div class="container">
  <div class="container mt-5">
    <div class="row justify-content-center">
      <div class="col-md-4">
        <div class="card p-4">
          <h2 class="card-title text-center mb-4">欢迎登录</h2>
          <div class="mb-3">
            <input
              type="text"
              class="form-control"
              placeholder="用户名"
              v-model="userName"
              required
            />
          </div>
          <div class="mb-3">
            <input
              type="password"
              class="form-control"
              placeholder="密码"
              v-model="password"
              required
            />
          </div>
          <div class="text-center">
            <button class="btn btn-primary btn-block" @click="login">
              登 录
            </button>
            <button class="btn btn-warning btn-block" style="margin-left: 20px">
              <router-link
                class="nav-link"
                :to="{ name: 'register' }"
                style="color: white"
              >
                注册→
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
  
  <script setup>
import { ElMessage } from "element-plus";
import { ref } from "vue";
import { useStore } from "vuex";
import router from "@/router/index";
import NavComponents from '@/components/nav/NavComponents.vue'

const userName = ref("");
const password = ref("");
const store = useStore();

const login = () => {
  store.dispatch("login", {
    userName: userName.value,
    password: password.value,
    success(msg) {
      ElMessage({
        type: "success",
        message: msg,
      });
      // 处理成功逻辑
      router.push({ name: "home" });
    },
    error(msg) {
      ElMessage({
        type: "error",
        message: msg,
      });
    },
  });
};
</script>

  <style scoped>
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.card-title {
  color: #007bff;
}
.btn-primary {
  background-color: #007bff;
  border: none;
}
.btn-primary:hover {
  background-color: #0056b3;
}
</style>